const trainings = () => {
    
    var carousel = $(".trainings-slider");
    var item = $(".trainings .items .training-item");
    
    item.each(function(index){
        if ($(this).find('.item-row').length > 1 && $(this).find('.more-term-wrap').length == 0) {
            $(this).append("<div class='more-term-wrap'><div class='more-term'><span>Więcej terminów</span></div></div>")
        }
    })

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }   

    $('.reminder-form').unbind().submit(function(e){
        e.preventDefault();
        
        var path = $(e.target).parents('.remember-btn').attr('base-path');
               
        var email = $(e.target).find('.pop__email').val()            
        var trainingName = $(e.target).find('.trainingName').val()
        var trainingDate = $(e.target).find('.trainingDate').val()
        var trainingDateEnd = $(e.target).find('.trainingDateEnd').val()

        var accept1 = $(e.target).find('.accept1').prop('checked');
        var accept2 = $(e.target).find('.accept2').prop('checked');
        
        $(e.target).find('.pop__email').removeClass('error');

        if (email == "") {
            $(e.target).find('.error-label').remove();
            $(e.target).append('<span class="error-label">Podaj adres email</span>')                
            return false

        } else if (!(validateEmail(email))) {
            $(e.target).find('.error-label').remove();
            $(e.target).append('<span class="error-label">Adres jest błędny</span>')
            $(e.target).find('.pop__email').addClass('error')

            return false
        } else if (!accept1 || !accept2) {
            $(e.target).find('.error-label').remove();
            $(e.target).append('<span class="error-label">Zaznacz obie zgody</span>')
            return false

        } else if (validateEmail(email)) {
            $(e.target).find('.error-label').remove();
            
            $.ajax({
                url: path + "ajax/send-training-reminder",
                type: 'POST',
                data: {
                    email: email,
                    trainingName: trainingName,
                    trainingDate: trainingDate,
                    trainingDateEnd: trainingDateEnd
                },
                dataType: "json",
                success: function (data) {
                    if(data.success){
                        $(e.target).append('<span class="valid-label">Zapisano</span>')
                        setTimeout(function(){
                            $('.pop').removeClass('show');
                            $(e.target).find('.pop__email').val("");
                            $(e.target).find('.error-label').remove();
                            $(e.target).find('.valid-label').remove();
                        },1000);
                    } else {
                        console.log('Reminder not sent.');
                        $(e.target).append('<span class="error-label">Spróbuj ponownie</span>')
                    }
                },
                error: function (error) {
                    console.log('error');
                    $(e.target).append('<span class="error-label">Spróbuj ponownie</span>')
                }
            });
        }
    });
    
    $('body').unbind().click(function(e){
        var btn = $(e.target).closest('.remember-btn');
        var emailField = $(e.target).closest('.remember-btn');
                
        setTimeout(function(){
            $(emailField).find('.pop__email').focus()
        },0); 
        
        if ($(e.target).hasClass('remember-button')) {
            setTimeout(function(){
                $(e.target).next().addClass('show');
            },0)    
        }
                
        if ($(e.target).hasClass('pop__email') || $(e.target).hasClass('pop_accept')) {
            return;
        }
        
        if ($(e.target).hasClass('pop__btn')) {
            return;
        }
        
        $('.pop').removeClass('show');
    });
        
    function handler1() {
        $(this).parents('.training-item').addClass('collapsed')
        $(this).find('span').text('Mniej terminów')
        
        $(this).one("click", handler2);
    }

    function handler2() {
        $(this).parents('.training-item').removeClass('collapsed')
        $(this).find('span').text('Więcej terminów')
        $(this).one("click", handler1);
    }
    $(".more-term").one("click", handler1);
    
    
    if(carousel.length > 0) {
        
        
        if ($(window).width() < 992) {
            if (carousel.hasClass('slick-initialized')) {
                carousel.slick('unslick');
            }
            $(carousel).slick({
                mobileFirst: true,
                arrows: false,
                slidesToShow: 1.1,
                infinite: false
            })
        } else {
            if (carousel.hasClass('slick-initialized')) {
                carousel.slick('unslick');
            }
        }   
        
        
        
        
    }
}

module.exports = {
    trainings
};